<template>
  <div class="wrapper">
    <Row class="exams">
      <Row class="exams-row">
        <Col span="6" class="exams-rowcol">
        <div class="exams-rowdiv">
          <img src="" alt="" />
          <div>
            <p>
              姓名：{{
                looksInfo.student ? looksInfo.student.real_name : null
              }}
            </p>
            <p>
              用户名：{{ looksInfo.student ? looksInfo.student.name : null }}
            </p>
          </div>
        </div>
        <Dropdown class="exams-rowcol-drop" trigger="click">
          <a href="javascript:void(0)">
            答题卡<Icon type="ios-arrow-down"></Icon>
          </a>

          <DropdownMenu slot="list" class="exams-rowcol-d">
            <DropdownItem v-show="examsList && examsList.length > 0" v-for="(meun, indexm) in examsList" :key="indexm">
              <p class="exams-rowcol-drop-tit">{{ meun.name }}</p>
              <div class="exams-rowcol-drop-div" v-show="meun.child && meun.child.length > 0"
                v-for="(item, index) in meun.child" :key="index">
                <p @click="gotoCar(indexm, 0, index)">{{ item.name }}</p>
                <div v-show="item.parts && item.parts.length > 0" v-for="(ite, i) in item.parts" :key="i"
                  @click="gotoCar(indexm, index, i)">
                  <a v-if="ite.question.ques_stem.length > 0 && !(is_3(ite, 2) || is_2(ite) || is_11(ite) || is_3(ite, 1) || is_1(ite) || is_12(ite) || is_5(ite, 1) || is_5(ite, 2) || is_8_9(ite) || is_6(ite) || is_7(ite) || is_4(ite) || is_10(ite))"
                    v-for="(it, iii) in ite.question.ques_stem" :key="'b' + iii" :style="{
                      borderColor: ite.question.ques_sub_headings[iii] && ite.question.ques_sub_headings[iii].answe
                        ? '#549ce9'
                        : '#aaa',
                      color: ite.question.ques_sub_headings[iii] && ite.question.ques_sub_headings[iii].answe
                        ? '#549ce9'
                        : '#aaa',
                    }">{{ ite.start + iii }}</a>
                  <a v-if="ite.question && (is_2(ite) || is_1(ite) || is_11(ite))" :style="{
                    borderColor: ite.question.answe
                      ? '#549ce9'
                      : '#aaa',
                    color: ite.question.answe
                      ? '#549ce9'
                      : '#aaa',
                  }">{{ ite.start }}</a>
                  <a v-if="ite.question && is_12(ite)" :style="{
                    borderColor: ite.question.answe
                      ? '#549ce9'
                      : '#aaa',
                    color: ite.question.answe
                      ? '#549ce9'
                      : '#aaa',
                  }">{{ ite.start }}</a>

                  <a v-if="ite.question.ques_stem.length > 0 && is_7(ite)" v-for="(it, iq) in ite.question.ques_answers"
                    :key="'c' + iq" :style="ite.question.ques_sub_headings && ite.question.ques_sub_headings[0] ? {
                      borderColor: ite.question.ques_sub_headings[0].answe[it.answer_k]
                        ? '#549ce9'
                        : '#aaa',
                      color: ite.question.ques_sub_headings[0].answe[it.answer_k]
                        ? '#549ce9'
                        : '#aaa',
                    } : {}">{{ ite.start + iq }}</a>
                  <a v-if="ite.question.formatData.sub_headings.length > 0 && is_8_9(ite)"
                    v-for="(it, iq) in ite.question.formatData.ques_answers" :key="'w' + iq" :style="ite.question.formatData.sub_headings && ite.question.formatData.sub_headings[0] ? {
                      borderColor: (ite.question.formatData.sub_headings[iq].options && ite.question.formatData.sub_headings[iq].answe[it.answer_k]) ||
                        (!ite.question.formatData.sub_headings[iq].options && ite.question.formatData.sub_headings[iq].answe)
                        ? '#549ce9'
                        : '#aaa',
                      color: (ite.question.formatData.sub_headings[iq].options && ite.question.formatData.sub_headings[iq].answe[it.answer_k]) ||
                        (!ite.question.formatData.sub_headings[iq].options && ite.question.formatData.sub_headings[iq].answe)
                        ? '#549ce9'
                        : '#aaa',
                    } : {}">{{ ite.start + iq }}</a>

                  <!-- 25 ------------------------------------------------ -->
                  <a v-if="ite.question.ques_sub_headings.length > 0 && !(is_4(ite) || is_11(ite) || is_7(ite) || is_1(ite) || is_12(ite) || is_8_9(ite) || is_2(ite) || is_3(ite, 2) || is_3(ite, 1) || is_10(ite) || is_5(ite, 1) || is_6(ite))"
                    v-for="(it, ii) in ite.question.ques_sub_headings" :key="'a' + ii" :style="{
                      borderColor: ite.question.formatData.sub_headings[ii].answe
                        ? '#549ce9'
                        : '#aaa',
                      color: ite.question.formatData.sub_headings[ii].answe
                        ? '#549ce9'
                        : '#aaa',
                    }">
                    {{ ite.start + ii }}
                    <!-- ite.question.ques_sub_headings -->
                    <!-- ite.question.formatData.sub_headings -->
                  </a>

                  <a v-if="ite.question.ques_sub_headings.length > 0 && is_6(ite)"
                    v-for="(it, id) in ite.question.ques_answers" :key="'f' + id" :style="ite.question.ques_sub_headings[0] && ite.question.ques_sub_headings[0].answe ? {
                      borderColor: ite.question.ques_sub_headings[id].answe[it.answer_k]
                        ? '#549ce9'
                        : '#aaa',
                      color: ite.question.ques_sub_headings[id].answe[it.answer_k]
                        ? '#549ce9'
                        : '#aaa',
                    } : {}">{{ ite.start + id }}</a>

                  <a v-if="ite.question.ques_sub_headings.length > 0 && is_4(ite)"
                    v-for="(it, id) in ite.question.ques_answers" :key="'e' + id" :style="ite.question.ques_sub_headings[0] && ite.question.ques_sub_headings[0].answe ? {
                      borderColor: ite.question.ques_sub_headings[0].answe[it.answer_k]
                        ? '#549ce9'
                        : '#aaa',
                      color: ite.question.ques_sub_headings[0].answe[it.answer_k]
                        ? '#549ce9'
                        : '#aaa',
                    } : {}">{{ ite.start + id }}</a>

                  <a v-if="ite.question.formatData.sub_headings.length > 0 && (is_5(ite, 1) || is_3(ite, 1) || is_3(ite, 2) || is_10(ite) || is_8_9(ite))"
                    v-for="(it, id) in ite.question.formatData.sub_headings" :key="'e' + id" :style="{
                      borderColor: Number(it.answe) >= 0 || isobj(it.answe) ? '#549ce9' : '#aaa', color: Number(it.answe) >= 0 || isobj(it.answe) ? '#549ce9' : '#aaa'
                    }">
                    {{ ite.start + id }}
                  </a>
                  <!-- <a v-if="ite.question.ques_stem&&ite.question.ques_stem[0].answe" @click="gotoCar(indexm,index,i)" :style="{'borderColor':ite.question.ques_stem[0].answe?'#549ce9':'#aaa','color':ite.question.ques_stem[0].answe?'#549ce9':'#aaa'}">{{ite.start}}</a> -->
                </div>
              </div>
            </DropdownItem>
          </DropdownMenu>

        </Dropdown>
        </Col>
        <Col span="13">
        <div class="exams-rowp">
          <p>{{ oneName }}</p>
          <img class="icon" src="@/assets/images/geli.png" alt="" />
          <p>{{ twoName }}</p>
        </div>
        </Col>
        <Col span="4" class="exams-right">
        <p>{{ hours }}:{{ minutes }}:{{ seconds }}</p>
        <Poptip transfer confirm title="您确定要交卷吗？点击确定后请等待确认。。" @on-ok="goSubmit">
          <Button size="small">交卷</Button>
        </Poptip>
        </Col>
      </Row>

      <div v-show="examsList && examsList.length > 0" v-for="(items, indexs) in examsList" :key="indexs"
        style="width: 100%">
        <div v-show="items.child && items.child.length > 0" v-for="(item, index) in items.child" :key="index"
          style="width: 100%">
          <div v-show="item.parts && item.parts.length > 0" v-for="(ite, i) in item.parts" :key="i" style="width: 100%">
            <Row class="exams-list" v-if="num[0] === indexs && num[1] === index && num[2] === i">
              <p class="exams-p">
                <audioplay v-if="is_3(ite, 2) || is_4(ite) || is_3(ite, 1)"
                  :myAudioUrl="ite.question.formatData.stem_src_audio"></audioplay>
              </p>
              <div class="questions">
                <div class="questions_title">
                  <!-- {{ ite.name }} (本题{{ ite.each_score[0] * 1 }}分) -->
                  {{ ite.name }}(本题{{
                    ite.total_score ? ite.total_score : "未知"
                  }}分)
                </div>
                <div class="empty" v-show="ite.question.length == 0">
                  暂无题目
                </div>
                <div style="color:#666;font-size:15px;padding: 0 20px 18px;">DIRECTIONS：{{ item.directions }}</div>
                <div class="question_content">
                  <!-- ***************题型1 选择题 ******************-->
                  <div v-if="is_1(ite)">
                    <h4>
                      <span class="index">{{ ite.start }}</span>
                      <div class="text" v-if="ite.question.formatData" v-html="ite.question.formatData.sub_heading">
                      </div>
                      <div class="text" v-if="ite.question.formatData" v-html="ite.question.formatData.stem_src_txt">
                      </div>
                    </h4>
                    <!-- 选择 -->
                    <div class="select">
                      <RadioGroup v-model="ite.question.answe" vertical>
                        <Radio :label="it.option_k" v-for="(it, ind) in ite.question.ques_options" :key="ind"
                          :id="it.option_k">
                          <span>{{ String.fromCharCode(65 + ind) }}.</span>
                          <span v-html="it.option"></span>
                        </Radio>
                      </RadioGroup>
                    </div>
                  </div>

                  <!-- ***************题型12 多选题 ******************-->

                  <div v-if="is_12(ite)">
                    <h4>
                      <span class="index">{{ ite.start }}</span>
                      <div class="text" v-if="ite.question.formatData" v-html="ite.question.formatData.sub_heading">
                      </div>
                      <div class="text" v-if="ite.question.formatData" v-html="ite.question.formatData.stem_src_txt">
                      </div>
                    </h4>
                    <!-- 选择 -->
                    <div class="select">
                      <!-- <RadioGroup v-model="ite.question.answe" vertical>
                        <Radio :label="it.option_k" v-for="(it, ind) in ite.question.ques_options" :key="ind"
                          :id="it.option_k">
                          <span>{{ String.fromCharCode(65 + ind) }}.</span>
                          <span v-html="it.option"></span>
                        </Radio>
                      </RadioGroup> -->

                      <CheckboxGroup class="duoxuan" v-model="ite.question.answe" vertical>


                        <Checkbox :label="it.option_k" v-for="(it, ind) in ite.question.ques_options" :key="ind"
                          :id="it.option_k">
                          <span class="text" v-html="String.fromCharCode(65 + ind) + '.' + it.option"></span>
                        </Checkbox>


                      </CheckboxGroup>


                    </div>
                  </div>

                  <!-- ***************题型2 填空题 ******************-->
                  <Col v-if="is_2(ite)">
                  <h4>
                    <span class="index">{{ ite.start }}</span>
                    <div class="text" v-if="ite.question.formatData"
                      v-html="set_input_2(ite, [indexs, index, i], ite.question.ques_sub_headings)"></div>
                  </h4>
                  <div style="display:flex">
                    <p>答案：</p>
                    <Input style="width:90%" v-model="ite.question.answe" type="textarea"
                      placeholder="Enter something...">
                    </Input>
                  </div>
                  </Col>
                  <!-- ***************题型3 听力选择题----单个问题 ******************-->

                  <Col v-if="is_3(ite, 2)">
                  <!-- //大标题 -->
                  <h4>
                    <span class="index">{{ ite.start }}</span>
                    <div class="text" v-if="have_sub_heading(ite)" v-html="set_sub_heading(ite, 0)"></div>
                    <div class="text" v-else-if="ite.question.ques_stem"
                      v-html="ite.question.ques_stem[0].stem_src_txt"></div>
                  </h4>
                  <!-- //大音频 -->
                  <!-- 选择 -->
                  <div class="select">
                    <RadioGroup v-model="ite.question.formatData.sub_headings[0].answe" vertical>
                      <Radio :label="it.option_k" v-for="(it, ind) in ite.question.ques_options" :key="ind"
                        :id="it.option_k">
                        <!-- {{ it.option_k }}. -->
                        <span>{{ String.fromCharCode(65 + ind) }}.</span>
                        <span v-html="it.option"></span>
                      </Radio>
                    </RadioGroup>
                  </div>
                  </Col>
                  <!-- ***************题型3 听力----多个问题 ******************-->
                  <Col v-if="is_3(ite, 1)">
                  <!-- //大标题 长对话-->
                  <h4>
                    <div class="text" v-if="ite.question.ques_stem" v-html="ite.question.ques_stem[0].stem_src_txt">
                    </div>
                  </h4>
                  <!-- 单个问题 -->
                  <div v-if="ite.question.formatData">
                    <div v-for="(li, i) in ite.question.formatData.sub_headings" :key="i">
                      <h4>
                        <span class="index">{{ ite.start + i }}</span>
                        <div class="text" v-if="li.sub_heading" v-html="li.sub_heading"></div>
                        <div class="text" v-if="li.sub_src_txt" v-html="li.sub_src_txt"></div>
                      </h4>
                      <div class="audio">
                        <audio controlsList="nodownload" style="width: 180px; height: 30px" v-if="li.sub_src_audio"
                          :ref="'audio' + index" controls :src="li.sub_src_audio"></audio>
                      </div>
                      <div class="select">
                        <RadioGroup vertical v-model="li.answe">
                          <Radio :label="String(ind)" v-for="(it, ind) in li.options" :key="ind" :id="it.option_k">
                            <span>{{ String.fromCharCode(65 + ind) }}.</span>
                            <span v-html="it.option"></span>
                          </Radio>
                        </RadioGroup>
                      </div>
                    </div>
                  </div>
                  </Col>

                  <!-- ***************题型4 听力填空题 ******************-->
                  <Col v-if="is_4(ite)">
                  <!-- //大标题 -->
                  <h4>
                    <div class="text" v-if="ite.question.formatData.sub_headings"
                      v-html="set_input_4(ite.start, ite.question.formatData.sub_headings, [indexs, index, i], ite.question.ques_sub_headings)">
                    </div>
                    <div class="text" v-if="ite.question.ques_stem" v-html="ite.question.ques_stem[0].stem_src_txt">
                    </div>
                  </h4>
                  <!-- //大音频 -->
                  </Col>

                  <!-- ***************题型5 阅读理解单个题 ******************-->
                  <Col v-if="is_5(ite, 2)">
                  <h4>
                    <span class="index">{{ ite.start }}</span>
                    <div class="text" v-if="have_sub_heading(ite)" v-html="set_sub_heading(ite, 0)"></div>
                    <div class="text" v-else-if="ite.question.ques_stem"
                      v-html="ite.question.ques_stem[0].stem_src_txt"></div>
                  </h4>
                  <!-- 选择 -->
                  <div class="select">
                    <RadioGroup v-model="ite.question.formatData.sub_headings[0].answe" vertical>
                      <Radio :label="it.option_k" v-for="(it, ind) in ite.question.ques_options" :key="ind"
                        :id="it.option_k">
                        <!-- {{ it.option_k }}. -->
                        <span>{{ String.fromCharCode(65 + ind) }}.</span>
                        <span v-html="it.option"></span>
                      </Radio>
                    </RadioGroup>
                  </div>
                  </Col>

                  <!-- ***************题型5 阅读理解多个题  ******************-->
                  <Col v-if="is_5(ite, 1)">
                  <!-- //大标题 -->
                  <h4>
                    <span class="index" style="background: #fff"></span>
                    <div class="text" v-if="ite.question.ques_stem" v-html="ite.question.ques_stem[0].stem_src_txt">
                    </div>
                  </h4>

                  <!-- 单个问题 -->
                  <div v-if="ite.question.formatData">
                    <div v-for="(li, i) in ite.question.formatData.sub_headings" :key="i">
                      <h4>
                        <span class="index">{{ ite.start + i }}</span>
                        <div class="text" v-if="li.sub_heading" v-html="li.sub_heading"></div>
                        <div class="text" v-if="li.sub_src_txt" v-html="li.sub_src_txt"></div>
                      </h4>
                      <!-- 55555 -->
                      <div class="select">
                        <RadioGroup vertical v-model="li.answe">
                          <div v-for="(it, ind) in li.options" :key="ind">
                            <Radio :label="ind" :id="it.option_k">
                              <span>{{ String.fromCharCode(65 + ind) }}.</span>
                              <span v-html="it.option"></span>
                            </Radio>
                          </div>
                        </RadioGroup>
                      </div>
                    </div>
                  </div>
                  </Col>

                  <!-- ***************题型6 长篇阅读_填空题  ******************-->
                  <Col v-if="is_6(ite)">
                  <!-- //大标题 -->
                  <h4>
                    <span class="index" style="background: #fff"></span>
                    <div class="text" v-if="ite.question.ques_stem" v-html="ite.question.ques_stem[0].stem_src_txt">
                    </div>
                  </h4>

                  <!-- 单个问题 -->
                  <div v-if="ite.question.formatData">
                    <div v-for="(li, lasi) in ite.question.formatData
                      .sub_headings" :key="lasi">
                      <h4>
                        <span class="index">{{ ite.start + lasi }}</span>
                        <div class="text" v-if="li" v-html="set_input_6(li, [
                          indexs,
                          index,
                          i,
                          lasi,
                        ], ite.question.ques_sub_headings[lasi])
                          "></div>
                      </h4>
                    </div>
                  </div>
                  </Col>

                  <!-- ***************题型7 n选n选择题  ******************-->
                  <Col v-if="is_7(ite)">
                  <h4>
                    <!-- <span class="index">{{ ite.start }}</span> -->
                    <!-- //大问题文章带input -->
                    <div class="text" v-if="
                      ite.question && ite.question.formatData.stem != ''
                    "
                      v-html="set_input(ite.start, ite.question.formatData, [indexs, index, i], ite.question.ques_sub_headings)">
                    </div>
                    <div class="text" v-else-if="ite.question.ques_stem"
                      v-html="ite.question.ques_stem[0].stem_src_txt"></div>
                  </h4>
                  <!-- 选择 -->
                  <div class="select_no">
                    <!-- <CheckboxGroup
                        v-model="ite.question.ques_stem[0].answe"
                        vertical
                      > -->
                    <p v-for="(it, ind) in ite.question.ques_options" :key="ind" :id="it.option_k" :type="ind"
                      :label="ind">
                      <!-- <span>{{ it.option_k }} . </span> -->
                      <span>{{ String.fromCharCode(65 + ind) }}.</span>
                      <span v-html="it.option"></span>
                    </p>
                    <!-- </CheckboxGroup> -->
                  </div>
                  </Col>

                  <!-- ***************题型8 选择题文本资源 题型9 填空题带文本资源 ******************-->
                  <Col v-if="is_8_9(ite)">
                  <!-- //大标题 -->
                  <h4>
                    <!-- <span class="index" style="background: #fff"></span> -->
                    <div class="text" v-if="ite.question.formatData" v-html="ite.question.formatData.stem_src_txt">
                    </div>
                  </h4>

                  <!-- 单个问题  -->
                  <div>
                    <div v-for="(li, ws) in ite.question.formatData.sub_headings" :key="ws">
                      <!--  这里 是  88888888888888 类型   -->
                      <div v-if="li.options && li.options.length > 0">
                        <h4>
                          <span class="index">{{ ite.start + ws }}</span>
                          <div class="text" v-if="li.sub_heading" v-html="li.sub_heading"></div>
                          <div class="text" v-if="li.sub_src_txt" v-html="li.sub_src_txt"></div>
                        </h4>

                        <div class="select">
                          <RadioGroup vertical v-model="li.answe">
                            <Radio :label="it.option_k" v-for="(it, ind) in li.options" :key="ind" :id="it.option_k">
                              {{ String.fromCharCode(65 + it.option_k * 1) }}.
                              <span v-html="it.option"></span>
                            </Radio>
                          </RadioGroup>
                        </div>
                      </div>

                      <!-- 填空题  这里是 99999999999999999999 类型 -->

                      <div v-else>
                        <h4>
                          <span class="index">{{ ite.start + ws }}</span>
                          <div class="text" v-if="li" v-html="set_input_9(li, [
                            indexs,
                            index,
                            i,
                            ws,
                          ], ite.question.formatData.sub_headings[ws])
                            "></div>
                        </h4>
                      </div>

                      <!-- 结束 -->
                    </div>
                  </div>
                  </Col>

                  <!-- ***************题型10 完形填空_填空题  ******************-->
                  <Col v-if="is_10(ite)">
                  <!-- //大标题 -->
                  <div class="text" v-if="ite.question.formatData" v-html="ite.question.formatData.stem_src_txt"></div>
                  <div v-for="(li, i) in ite.question.formatData.sub_headings" :key="i">
                    <h4>
                      <span class="index">{{ ite.start + i }}</span>
                      <div class="text" v-if="have_sub_heading(ite)" v-html="set_sub_heading(ite, i)"></div>
                      <!-- <div
                        class="text"
                        v-if="ite.question.ques_sub_headings"
                        v-html="set_input_10(li, [indexs, index, i])"
                      ></div> -->
                    </h4>
                    <!-- 选择 -->
                    <div class="select">
                      <RadioGroup v-model="li.answe" vertical>
                        <Radio :label="it.option_k" v-for="(it, ind) in li.options" :key="ind" :id="it.option_k">
                          <!-- {{ it.option_k }}. -->

                          <span>{{ String.fromCharCode(65 + ind) }}.</span>
                          <span v-html="it.option"></span>
                        </Radio>
                      </RadioGroup>
                    </div>
                  </div>
                  </Col>
                  <!-- <Col v-if="is_10(ite)"> -->
                  <!-- //大标题 -->
                  <!-- <h4>
                      <span class="index" style="background: #fff"></span>
                      <div
                        class="text"
                        v-if="ite.question.ques_sub_headings"
                        v-html="set_input_10(ite, [indexs, index, i])"
                      ></div>
                    </h4> -->
                  <!-- 单个问题 -->
                  <!-- <div v-if="ite.question.formatData">
                      <div
                        v-for="(li, i) in ite.question.formatData.sub_headings"
                        :key="i"
                      >
                        <h4>
                          <span class="index" v-if="ite.start">{{
                            ite.start + i
                          }}</span>
                        </h4>

                        <div class="select">
                          <RadioGroup
                            vertical
                            v-model="ite.question.ques_sub_headings[i].answe"
                          >
                            <Radio
                              :label="String(ind)"
                              v-for="(it, ind) in li.options"
                              :key="ind"
                              :id="it.option_k"
                            >
                              <span v-html="it.option"></span>
                            </Radio>
                          </RadioGroup>
                        </div>
                      </div>
                    </div> -->
                  <!-- </Col> -->

                  <!-- 写作题 -->
                  <Col v-if="is_11(ite)">
                  <div style="height: 12px"></div>
                  <h4>
                    <span class="index">{{ ite.start }}</span>
                    <div v-if="ite.question.ques_stem">
                      <p v-html="ite.question.ques_stem[0].stem"></p>
                    </div>
                  </h4>
                  <div style="height: 12px"></div>
                  <p>
                    字数建议：下限：
                    <span v-html="ite.question.ques_stem[0].limit_l"></span>上限：<span
                      v-html="ite.question.ques_stem[0].limit_r"></span>
                  </p>

                  <div style="height: 12px"></div>
                  <Input v-model="ite.question.answe" :maxlength="ite.question.ques_stem[0].limit_r" show-word-limit
                    type="textarea" placeholder="Enter something...">
                  </Input>
                  <div style="height: 12px"></div>
                  </Col>
                </div>
              </div>
            </Row>
            <Row style="width: 100%; margin-top: 10px" v-if="num[0] === indexs && num[1] === index && num[2] === i">
              <Col :span="20">
              </Col>
              <Col :span="4"><Button @click="prex(indexs, index, i)" :disabled="preDisabled">上一题</Button><Button
                @click="next(indexs, index, i)" :disabled="nextDisabled">下一题</Button></Col>
            </Row>
          </div>
        </div>
      </div>
    </Row>

    <Modal v-model="lookShow" @on-cancel="lookcancel()" title="">
      <Row class="shuomingpop">
        <p class="shuomingp">请核对个人信息</p>
        <Col span="24" class="xinfos">
        <p>用户名：{{ looksInfo.student ? looksInfo.student.name : null }}</p>
        <p>
          姓名：{{ looksInfo.student ? looksInfo.student.real_name : null }}
        </p>
        <p>
          所属校区：{{
            looksInfo.student ? looksInfo.student.campus_name : null
          }}
        </p>
        </Col>
        <Col span="24" class="shuoming">
        <div style="padding-left: 20px;padding-bottom: 15px;" v-if="is_free == 2">考试性质：免费，扣除积分： 0分</div>
        <div style="padding-left: 20px;padding-bottom: 15px;" v-if="is_free == 1">考试性质：收费，扣除积分： {{ price }}分</div>

        <p>考试说明：</p>
        <div v-html="looksInfo.student ? looksInfo.examination.remark : null"></div>
        </Col>
      </Row>
      <div slot="footer">
        <Button type="text" size="small" @click="lookcancel">取消</Button>
        <Button type="primary" size="small" @click="sureInfo">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
  import audioplay from "./audioplay.vue"
  export default {
    components: {
      audioplay,
    },
    data() {
      return {
        preDisabled: true, //上禁用按钮
        nextDisabled: false, //下禁用按钮
        num: [0, 0, 0], //第几题
        answerList: [], //所有题的答案或分数
        examsList: [],
        lookShow: true,
        looksInfo: {},
        leftTime: 0,
        hours: "00",
        minutes: "00",
        seconds: "00",
        oneName: "",
        twoName: "",
        timer: null,
        //当前考试的是否免费 cjp 2023.7.25
        is_free: 2, // 当前考试是否免费 1 付费，2 免费
        price: 0, // 当前考试需要支付的价格


      }
    },
    computed: {},
    watch: {
      //第一题和最后一题禁用按钮
      num(now) {
        var i = this.examsList.length - 1
        var a = this.examsList[i].child.length - 1
        var w = this.examsList[i].child[a].parts.length - 1
        if (now[0] == i && now[1] == a && now[2] == w) {
          this.nextDisabled = true
        } else {
          this.nextDisabled = false
        }
        if (now[0] == 0 && now[1] == 0 && now[2] < 1) {
          this.preDisabled = true
        } else {
          this.preDisabled = false
        }
      },
      examsList: {
        handler(data) {
          // console.log(12, data)
        },
        deep: true,
      },
    },
    mounted() {
      setInterval(() => {
        if (window._inputForceRefresh === 1) {
          this.renderInput()
          let doms_6 = document.querySelectorAll(".input6")
          this.resetInputSub(doms_6, 6)
          window._inputForceRefresh = 0
          this.$forceUpdate()
        }
      }, 2000)
    },
    activated() {
      window.clearTimeout(this.timer)
      this.looksInfo = {}
      this.getstudent()
    },
    beforeRouteLeave(to, form, next) {
      this.saves()
      next()
    },
    destroyed() {
      this.saves()
    },
    methods: {
      have_sub_heading(ite) {
        return (
          ite.question.ques_sub_headings &&
          ite.question.ques_sub_headings.length > 0 &&
          ite.question.ques_sub_headings[0].sub_heading != ""
        )
      },
      set_sub_heading(ite, i) {
        return ite.question.ques_sub_headings[i].sub_heading
      },

      // 完型填空类往inpu 中添加文字
      set_input(start, item, as, answe) {
        var asw = answe[0] ? answe[0].answe : answe
        if (!asw) {
          answe.push({ answe: {} })
          asw = answe[0].answe
        }
        let stem = item.stem
        let answer = item.answer
        let arr = stem.split("<Input/>")
        let newArr = ""
        arr.map(function (item, index) {
          if (index < arr.length - 1) {
            var ar = answer[index] ? answer[index].answer_k : ""
            newArr +=
              item +
              `<pre>` +
              (start + index) +
              `<Input class="input7" value='${asw[ar] ? asw[ar] : "''"
              }' data-sort='${ar}' data-v='${as}' /></pre>`
          } else {
            newArr += item
          }
        })
        return newArr
      },
      //题型2的 填空题往inpu 中添加文字
      set_input_2(ite, as, answe) {
        var asw = answe[0] ? answe[0].answe : []
        let stem = ite.question.formatData.stem
        let answer = ite.question.formatData.answer
        let arr = stem.split("<Input/>")
        let newArr = ""
        arr.map(function (item, index) {
          if (index < arr.length - 1) {
            var ar = answer[index] ? answer[index].answer_k : ""
            newArr +=
              item +
              `<Input class="input2" disabled rows="3" cols="20" value='${asw[ar] ? asw[ar] : "''"
              }' data-sort='${ar}' data-v='${as}'></Input>`
          } else {
            newArr += item
          }
        })
        return newArr
      },
      // ite.start,ite.question.formatData,[indexs, index, i],ite.question.ques_sub_headings
      //题型4的 填空题往input 中添加文字
      set_input_4(start, item, as, answe) {
        // console.log(answe)
        var asw = answe[0] ? answe[0].answe : {}
        if (!answe[0].answe) {
          // answe[0].answe={}
          // asw=answe[0].answe
          asw = {}
        }
        let stem = item[0].sub_heading
        let answer = item[0].answer
        let arr = stem ? stem.split("<Input/>") : []
        let newArr = ""
        arr.map(function (item, index) {
          if (index < arr.length - 1) {
            var ar = answer[index] ? answer[index].answer_k : ""
            newArr +=
              item +
              `<pre>` +
              (start + index) +
              `<Input class="input4" value='${asw[ar] ? asw[ar] : "''"
              }' data-sort='${ar}' data-v='${as}' /></pre>`
          } else {
            newArr += item
          }
        })
        return newArr
      },
      // 6类型填空类往inpu 中添加文字
      set_input_6(item, as, answe) {
        let stem = item.sub_heading
        let answer = item.answer
        var asw = answe ? answe.answe : {}
        if (!asw || !answe.answe) {
          answe.answe = {}
          asw = answe.answe
        }
        let arr = stem.split("<Input/>")
        let newArr = ""
        arr.map(function (it, index) {
          if (index < arr.length - 1) {
            var ar = answer[index] ? answer[index].answer_k : ""
            newArr +=
              it +
              `<pre><Input class="input6" onblur="window._inputForceRefresh = 1" value='${asw[ar] ? asw[ar] : "''"
              }' data-sort='${ar}' data-v='${as}' /></pre>`
          } else {
            newArr += it
          }
        })
        return newArr
      },
      // 9类型填空类往inpu 中添加文字
      set_input_9(item, as, answe) {
        let stem = item.sub_heading //题
        let answer = item.answer //答案
        var asw = answe ? answe.answe : {}
        if (!asw || !answe.answe) {
          answe.answe = {}
          asw = answe.answe
        }
        let arr = stem.split("<Input/>")
        let newArr = ""
        arr.map(function (it, index) {
          if (index < arr.length - 1) {
            let ar = answer[index] ? answer[index].answer_k : ""
            newArr +=
              it +
              `<pre><Input class="input9" value='${asw[ar] ? asw[ar] : "''"
              }' data-sort='${ar}' data-v='${as}' /></pre>`
          } else {
            newArr += it
          }
        })
        return newArr
      },
      // 10类型完形填空替换
      set_input_10(ite, as) {
        let [stem, newStem, sub] = [
          ite.stem_src_txt ? ite.stem_src_txt : "",
          ite.stem_src_txt ? ite.stem_src_txt : "",
          ite.sub_headings,
        ]
        sub.forEach((item, index) => {
          // as.push(index)
          let clickone = `document.querySelector('.re${index}').style.display==''`
            ? `document.querySelector('.re${index}').style.display='none'`
            : `document.querySelector('.re${index}').style.display=''`
          // 保存subheadings的位置
          // console.log(styleA,index,stem.match(/__.\d?__/g)[index],styleB)
          let select =
            `<div style="position:relative;cursor:pointer">` +
            `<p onclick="${clickone}"><span data-k="" data-v='"${as}"' class="input10 te${index}">${stem.match(/__.\d?__/g)[index]
            }</span></p>` +
            `<div style="display:none;position:absolute;z-index:10;width: 400px;background: rgba(0,0,0,0.8);color: #fff;padding: 10px;" class="re${index}">`

          for (let i = 0; i < item.options.length; i++) {
            let option = item.options[i]
            let clicktwo = `document.querySelector('.te${index}').dataset.k=${option.option_k};document.querySelector('.te${index}').innerHTML='__'+ (String.fromCharCode(parseInt(document.querySelector('.item${i}${index}').dataset.v)+65))+'__';document.querySelector('.re${index}').style.display='none'`
            select += `<div style="cursor:pointer;" class="item${i}${index}" onclick="${clicktwo}" data-v='${option.option_k}'>${option.option}</div>`
          }
          select += "</div></div>"
          newStem = newStem.replace(stem.match(/__.\d?__/g)[index], select)
        })
        return newStem
      },
      //判断类型
      //基础选择题
      is_1(item) {
        if (item.question && item.question.formatData) {
          return item.question.question_type.basic_ques_types == 1
        }
      },
      is_12(item) {
        if (item.question && item.question.formatData) {
          return item.question.question_type.basic_ques_types == 12
        }
      },
      //基础填空题
      is_2(item) {
        if (item.question && item.question.formatData) {
          return item.question.question_type.basic_ques_types == "2"
        }
      },
      //听力选择题
      is_3(item, num) {
        if (item.question && item.question.formatData) {
          return (
            item.question.question_type.basic_ques_types == 3 &&
            item.question.question_type.batch == num
          )
        }
      },
      //听力填空题
      is_4(item) {
        if (item.question && item.question.formatData) {
          return item.question.question_type.basic_ques_types == 4
        }
      },
      //阅读理解填空题 多个
      is_5(item, num) {
        if (item.question && item.question.formatData) {
          return (
            item.question.question_type.basic_ques_types == 5 &&
            item.question.question_type.batch == num
          )
        }
      },
      //长篇阅读
      is_6(item) {
        if (item.question && item.question.formatData) {
          return item.question.question_type.basic_ques_types == 6
        }
      },
      //  <!-- n选n选择题 -->
      is_7(item) {
        if (item.question && item.question.formatData) {
          return item.question.question_type.basic_ques_types == 7
        }
      },
      is_8_9(item) {
        if (item.question && item.question.formatData) {
          return item.question.question_type.basic_ques_types == "8,9"
        }
      },
      // <!-- 完形填空 -->
      is_10(item) {
        if (item.question && item.question.formatData) {
          return item.question.question_type.basic_ques_types == 10
        }
      },
      //是否是写作题
      is_11(item) {
        if (item.question && item.question.formatData) {
          let tag = item.question.question_type.basic_ques_types == 11
          if (!item.question.ques_sub_headings[0]) {
            item.question.ques_sub_headings[0] = { answe: {} }
          }
          return tag
        }
      },
      //填空题为空
      isobj(data) {
        if (!data || JSON.stringify(data) == "{}") {
          return false
        } else {
          let arr = Object.values(data)
          if (arr[0]) {
            return true
          } else {
            return false
          }
        }
      },
      // 倒计时 -------------------
      countTime() {
        const leftTime = this.leftTime
        // console.log(leftTime,77777)
        // 定义变量 d,h,m,s保存倒计时的时间
        if (leftTime > 0) {
          // 时
          const h = Math.floor((leftTime / 1000 / 60 / 60) % 24)
          this.hours = h < 10 ? "0" + h : h
          // 分
          const m = Math.floor((leftTime / 1000 / 60) % 60)
          this.minutes = m < 10 ? "0" + m : m
          // 秒
          const s = Math.floor((leftTime / 1000) % 60)
          this.seconds = s < 10 ? "0" + s : s
        } else {
          this.hours = "00"
          this.minutes = "00"
          this.seconds = "00"
          this.goSubmit()
        }
        // 等于0的时候不调用
        if (
          Number(this.hours) === 0 &&
          Number(this.minutes) === 0 &&
          Number(this.seconds) === 0
        ) {
          this.goSubmit()
          return
        } else {
          // 递归每秒调用countTime方法，显示动态时间效果,
          this.leftTime -= 1000
          this.timer = setTimeout(this.countTime, 1000)
        }
      },
      getstudent() {
        var that = this
        that.examsList = []
        that.leftTime = 0
        console.log("/app/exam_enroll_student/index2?id=" + that.$route.query.examination_id)
        that.$axios
          .get("/app/exam_enroll_student/index2?id=" + that.$route.query.examination_id)
          .then((res) => {
            if (res.code == 1) {
              console.log(res.data)
              // cjp 获取当前考试的是否免费以及价格
              try {
                that.is_free = res.data.examination.is_free
                that.price = res.data.examination.price
                console.log("ok")
              } catch (e) {
                console.log(e)
              }
              console.log("===")
              console.log(that.is_free)
              //
              that.looksInfo = res.data
              if (res.data.status == 1) {
                that.lookShow = true
                return false
              }

              //
              that.lookShow = false
              console.log("/app/exam_enroll_student/getExamData2?examination_id=" + that.$route.query.examination_id)
              that.$axios
                .get(
                  "/app/exam_enroll_student/getExamData2?examination_id=" +
                  that.$route.query.examination_id
                )
                .then((res1) => {
                  if (res1.code == 1) {
                    if (
                      res1.data.answer_data &&
                      JSON.parse(res1.data.answer_data).length > 0
                    ) {
                      // if(!res1.data.left_time||res1.data.left_time==0){
                      //   that.goSubmit();
                      //  }
                      if (res1.data.left_time) {
                        that.leftTime = res1.data.left_time
                        // 倒计时-------------------------------
                        that.countTime()
                      }
                      that.examsList = JSON.parse(res1.data.answer_data)
                      that.oneName = that.examsList[0]
                        ? that.examsList[0].name
                        : null
                      console.log("==that.examsList=1 ")
                      console.log(that.examsList)
                      console.log("==that.examsList=2 ")
                      that.twoName =
                        that.examsList[0] && that.examsList[0].child[0]
                          ? that.examsList[0].child[0].name
                          : null
                      return false
                    } else if (
                      res.data.examination &&
                      res.data.examination.time_limit
                    ) {
                      that.leftTime = res.data.examination.time_limit * 60 * 1000
                      // 倒计时-------------------------------
                      that.countTime()
                    }
                    console.log("==that.examsList=5 ")
                    that.getshijuan(that.$route.query.examination_id)
                  } else {
                    that.$Message.error(res1.msg)
                  }
                })
            } else {
              that.$Message.error(res.msg)
            }
          })
      },
      getshijuan(id) {
        var that = this
        console.log("/app/exam_enroll_student/getInfo?examination_id=" + id)
        that.$axios
          .get("/app/exam_enroll_student/getInfo?examination_id=" + id)
          .then((res) => {
            if (res.code == 1) {
              that.examsList = res.data.catalog
              console.log("试卷信息:")
              console.log(that.examsList)
              that.oneName = that.examsList[0] ? that.examsList[0].name : null
              that.twoName =
                that.examsList[0] && that.examsList[0].child[0]
                  ? that.examsList[0].child[0].name
                  : null
            } else {
              that.$Message.error(res.msg)
            }
          })
      },
      gotoCar(w, p, s) {
        this.num[0] = w
        this.num[1] = p
        this.num[2] = s
        this.num.forEach((item, index) => {
          this.$set(this.num, index, item)
        })
        this.oneName = this.examsList[this.num[0]]
          ? this.examsList[this.num[0]].name
          : null
        this.twoName =
          this.examsList[this.num[0]] &&
            this.examsList[this.num[0]].child[this.num[1]]
            ? this.examsList[this.num[0]].child[this.num[1]].name
            : null
        // console.log(this.num)
        this.$forceUpdate()
      },
      next(w, p, s) {
        // 情况2 上一题下一题前保存input值
        this.renderInput()
        var that = this
        that.preDisabled = false
        var i = that.examsList.length - 1
        var a = that.examsList[w].child.length - 1
        var d = that.examsList[w].child[p].parts.length - 1
        that.num[0] = w
        that.num[1] = p
        that.num[2] = s
        if (that.num[0] <= i && that.num[1] <= a && that.num[2] <= d) {
          if (that.num[0] <= i && that.num[1] <= a && that.num[2] < d) {
            that.num[2] += 1
            // console.log('1that.num[0] <= i,that.num[1] <= a,that.num[2] < d')
          } else if (that.num[0] <= i && that.num[1] <= a && that.num[2] < d) {
            that.num[2] += 1
            // console.log('2that.num[0] <= i,that.num[1] <= a,that.num[2] < d')
          } else if (that.num[0] == i && that.num[1] == a && that.num[2] == d) {
            that.num[0] += 1
            that.num[1] = 0
            that.num[2] = 0
            // console.log('3that.num[0]=i,that.num[1]=a,that.num[2]=d')
          } else if (that.num[0] < i && that.num[1] == a && that.num[2] == d) {
            that.num[0] += 1
            that.num[1] = 0
            that.num[2] = 0
            // console.log(that.num,'4that.num[0]<i,that.num[1] =a,that.num[2]=d')
          } else if (that.num[0] <= i && that.num[1] < a && that.num[2] == d) {
            that.num[1] += 1
            that.num[2] = 0
            // console.log('5that.num[0]<= i,that.num[1]<a,that.num[2] =d')
          }
          // console.log(that.num,i,a,d)
          that.num.forEach((item, index) => {
            that.$set(that.num, index, item)
          })
          that.oneName = that.examsList[that.num[0]]
            ? that.examsList[that.num[0]].name
            : null
          that.twoName =
            that.examsList[that.num[0]] &&
              that.examsList[that.num[0]].child[that.num[1]]
              ? that.examsList[that.num[0]].child[that.num[1]].name
              : null
          // console.log(this.num)
          that.$nextTick(function () {
            that.$bus.$emit("updateAudio")
          })
          that.$forceUpdate()
        }
      },
      prex(w, p, s) {
        // 上一题下一题前渲染input
        this.renderInput()
        var that = this
        if (that.num[0] === 0 && that.num[1] === 0 && that.num[2] === 0) {
          that.num = [0, 0, 0]
          that.oneName = that.examsList[0] ? that.examsList[0].name : null
          that.twoName =
            that.examsList[0] && that.examsList[0].child[0]
              ? that.examsList[0].child[0].name
              : null
        } else {
          var i = that.examsList.length - 1
          var a = that.examsList[w].child.length - 1
          // var d = that.examsList[w].child[p].parts.length - 1;
          that.num[0] = w
          that.num[1] = p
          that.num[2] = s
          //  console.log(a,d,w,p,s,that.num)
          // console.log(that.examsList)
          if (that.num[0] == 1 && that.num[1] == 0 && that.num[2] == 0) {
            // that.num = [0, 0, 0];
            that.num[0] = 0
            that.num[1] = that.examsList[0].child.length - 1
            that.num[2] = that.examsList[0].child[that.num[1]].parts.length - 1
            // console.log('2')
          } else if (that.num[0] == 0 && that.num[1] > 0 && that.num[2] == 0) {
            that.num[1] -= 1
            that.num[2] = that.examsList[w].child[p - 1].parts.length - 1
            // console.log('2')
          } else if (that.num[0] <= i && that.num[1] < a && that.num[2] > 0) {
            that.num[2] -= 1
            // console.log('5')
          } else if (that.num[0] > 0 && that.num[1] > 0 && that.num[2] == 0) {
            that.num[1] -= 1
            that.num[2] = that.examsList[w].child[p - 1].parts.length - 1
            // console.log('1',that.examsList[w].child,that.examsList[w].child[p-1].parts)
          } else if (that.num[0] <= i && that.num[1] == a && that.num[2] > 0) {
            that.num[2] -= 1
            // console.log('5q')
          } else if (that.num[0] > 0 && that.num[1] == 0 && that.num[2] == 0) {
            // console.log('11',that.examsList[w-1].child.length,that.examsList[w-1].child.length)
            that.num[0] -= 1
            that.num[1] = that.examsList[that.num[0]].child.length
              ? that.examsList[that.num[0]].child.length - 1
              : 0
            that.num[2] = that.examsList[that.num[0]].child[that.num[1]]
              ? that.examsList[that.num[0]].child[that.num[1]].parts.length - 1
              : 0
          }
          //  console.log(that.num,i,a,d)
          that.num.forEach((item, index) => {
            that.$set(that.num, index, item)
          })
          that.oneName = that.examsList[that.num[0]]
            ? that.examsList[that.num[0]].name
            : null
          that.twoName =
            that.examsList[that.num[0]] &&
              that.examsList[that.num[0]].child[that.num[1]]
              ? that.examsList[that.num[0]].child[that.num[1]].name
              : null
          that.$nextTick(function () {
            that.$bus.$emit("updateAudio")
          })
          that.$forceUpdate()
        }
      },
      saves() {
        var that = this
        // that.answerList = [];
        // if(that.examsList){
        //   that.examsList.forEach((item) => {
        //   var arr = [];
        //   for (var i in item.child) {
        //     var obj = item.child[i];
        //     var part = [];
        //     for (var a in obj.parts) {
        //       part.push({ que_id: obj.parts[a].id, answer: obj.parts[a].answe,id:obj.parts[a].id,name:obj.parts[a].name });
        //     }
        //     arr.push({ child: part,id:obj.id,name:obj.name,template_id:obj.template_id});
        //   }
        //   that.answerList.push(arr);
        // });
        // }
        that.renderInput()
        console.log(that.examsList)
        console.log("/app/exam_enroll_student/lastOrNextSave")
        that.$axios
          .post("/app/exam_enroll_student/lastOrNextSave", {
            answer_data: JSON.stringify(that.examsList),
            examination_id: that.$route.query.examination_id,
            left_time: that.leftTime,
          })
          .then((res) => {
            if (res.code == 1) {
              window.clearTimeout(that.timer)
              // that.$Message.success('暂存成功')
              // that.$router.go(-1)
            } else {
              that.$Message.error(res.msg)
            }
          })
      },
      resetInputSub(doms, type) {
        // 将newArr制作为与题型数据结构一一对应的数组
        // if((type == 2||type == 7)&&doms[0]) {
        //    doms.forEach(res=> {
        //     let is = res.getAttribute('data-v').split(',')
        //     let sub = this.examsList[is[0]].child[is[1]].parts[is[2]].question.ques_sub_headings
        //     // console.log(sub,this.examsList[is[0]].child[is[1]].parts[is[2]].question)
        //     if(!sub||!sub[0]||!sub[0].answe){
        //       sub[0] = {answe: []}
        //       sub[0].answe.push(res.value)
        //     }
        //   })
        //   this.examsList[is[0]].child[is[1]].parts[is[2]].question.ques_sub_headings=sub
        // }
        // if((type == 2||type == 7)&&doms[0]) {
        if (type == 7 && doms[0]) {
          let newArr = []
          doms.forEach((res) => {
            if (newArr.indexOf(res.getAttribute("data-sort")) == -1) {
              newArr.push({ sort: res.getAttribute("data-sort") })
            }
          })
          let is = doms[0].getAttribute("data-v").split(",")
          let sub =
            this.examsList[is[0]].child[is[1]].parts[is[2]].question
              .ques_sub_headings
          console.log(sub, newArr, is)
          newArr.forEach((res, index) => {
            for (let i = 0; i < doms.length; i++) {
              if (doms[i].getAttribute("data-sort") == res.sort) {
                if (type == 2) sub = []
                if (!sub[0] || !sub[0].answe) {
                  sub[0] = { answe: {} }
                }
                sub[0].answe[res.sort] = doms[i].value
              }
            }
          })
          this.examsList[is[0]].child[is[1]].parts[
            is[2]
          ].question.ques_sub_headings = sub
          // console.log(this.examsList[is[0]].child[is[1]].parts[is[2]],sub,'this.examsList[is[0]].child[is[1]].parts[is[2]].question')
        }
        if (type == 4 && doms[0]) {
          let newArr = []
          doms.forEach((res) => {
            if (newArr.indexOf(res.getAttribute("data-sort")) == -1) {
              newArr.push({ sort: res.getAttribute("data-sort") })
            }
          })
          let is = doms[0].getAttribute("data-v").split(",")
          let sub =
            this.examsList[is[0]].child[is[1]].parts[is[2]].question
              .ques_sub_headings[0]
          newArr.forEach((res, index) => {
            for (let i = 0; i < doms.length; i++) {
              if (doms[i].getAttribute("data-sort") == res.sort) {
                if (!sub.answe) {
                  sub.answe = {}
                }
                sub.answe[res.sort] = doms[i].value
              }
            }
          })

          this.examsList[is[0]].child[is[1]].parts[
            is[2]
          ].question.ques_sub_headings[0].answe = sub.answe

          console.log(
            this.examsList[is[0]].child[is[1]].parts[is[2]].question
              .ques_sub_headings
          )
          // 在每个input中去判断，此input属于subheading数据的哪个下标的input
          // newArr.forEach((res, index) => {
          //   for(let i = 0; i < doms.length; i++) {
          //     if(doms[i].getAttribute('data-sort') == res.sort) {
          //     let is = doms[i].getAttribute('data-v').split(',')
          //     let sub = this.examsList[is[0]].child[is[1]].parts[is[2]].question.ques_sub_headings[index]
          //       if(!sub.answe) {
          //         sub.answe = []
          //       }
          //       sub.answe.push(doms[i].value)
          //       // console.log(sub)
          //     }
          //   }
          // })
        }
        if (type == 6 && doms[0]) {
          let newArr = []
          doms.forEach((res) => {
            if (newArr.indexOf(res.getAttribute("data-sort")) == -1) {
              newArr.push({ sort: res.getAttribute("data-sort") })
            }
          })

          newArr.forEach((res, index) => {
            for (let i = 0; i < doms.length; i++) {
              let is = doms[i].getAttribute("data-v").split(",")
              let sub =
                this.examsList[is[0]].child[is[1]].parts[is[2]].question
                  .ques_sub_headings[is[3]]
              if (doms[i].getAttribute("data-sort") == res.sort) {
                if (!sub.answe) {
                  sub.answe = {}
                }
                sub.answe[res.sort] = doms[i].value
              }
              this.examsList[is[0]].child[is[1]].parts[
                is[2]
              ].question.ques_sub_headings[is[3]] = sub
            }
          })
        }
        if (type == 9 && doms[0]) {
          let newArr = []
          doms.forEach((res) => {
            if (newArr.indexOf(res.getAttribute("data-sort")) == -1) {
              newArr.push({ sort: res.getAttribute("data-sort") })
            }
          })
          newArr.forEach((res, index) => {
            for (let i = 0; i < doms.length; i++) {
              let is = doms[i].getAttribute("data-v").split(",")
              let subs =
                this.examsList[is[0]].child[is[1]].parts[is[2]].question
                  .formatData.sub_headings[is[3]]
              if (doms[i].getAttribute("data-sort") == res.sort) {
                if (!subs.answe) {
                  subs.answe = {}
                }
                subs.answe[res.sort] = doms[i].value
              }
              this.examsList[is[0]].child[is[1]].parts[
                is[2]
              ].question.formatData.sub_headings[is[3]] = subs
            }
          })
        }
        if (type == 10) {
          doms.forEach((res) => {
            let is = res.getAttribute("data-v").split(",")
            let k = res.getAttribute("data-k")
            let sub =
              this.examsList[is[0]].child[is[1]].parts[is[2]].question
                .ques_sub_headings[is[3]]
            if (!sub.answe) sub.answe = []
            sub.answe.push(k)
            // console.log(sub)
          })
        }
      },
      // 重新渲染input数据到subhead
      renderInput() {
        let doms_2 = document.querySelectorAll(".input2")
        let doms_7 = document.querySelectorAll(".input7")
        let doms_4 = document.querySelectorAll(".input4")
        let doms_6 = document.querySelectorAll(".input6")
        let doms_9 = document.querySelectorAll(".input9")
        // let doms_10 = document.querySelectorAll('.input10')
        if (doms_2) this.resetInputSub(doms_2, 2)
        if (doms_4) this.resetInputSub(doms_4, 4)
        if (doms_6) this.resetInputSub(doms_6, 6)
        if (doms_7) this.resetInputSub(doms_7, 7)
        if (doms_9) this.resetInputSub(doms_9, 9)
        // if(doms_10) this.resetInputSub(doms_10, 10)
      },
      goSubmit() {
        // 情况1 当前提型，不继续进行，直接交卷前题前保存input值
        this.renderInput()
        var that = this
        that.answerList = []
        // console.log(this.examsList)
        that.examsList.forEach((item) => {
          for (let i in item.child) {
            let obj = item.child[i]
            for (var a in obj.parts) {
              let [question, sub, sem, type, part, obs] = [
                obj.parts[a].question,
                obj.parts[a].question.ques_sub_headings,
                obj.parts[a].question.formatData.sub_headings,
                obj.parts[a].question.question_type,
                {},
                [],
              ]
              switch (type ? type.basic_ques_types : "") {
                case "1":
                case "2":
                  var oo = []
                  if (
                    question.answe &&
                    question.answe != null &&
                    question.answe != ""
                  ) {
                    oo.push({ answe: question.answe })
                    obs = oo
                  } else {
                    obs = []
                  }
                  break
                case "12":
                  var oo = []
                  if (
                    question.answe &&
                    question.answe != null &&
                    question.answe != ""
                  ) {

                    // oo.push({ answe: question.answe })
                    oo.push({ answe: question.answe })
                    obs = oo
                  } else {
                    obs = []
                  }
                  break
                case "7":
                  var ob = sub[0] ? sub[0]["answe"] : {}
                  obs.push({ answe: ob })
                  break
                case "5":
                  obs = sem
                  break
                case "4":
                  var on = sub[0].answe
                  obs.push({ answe: on })
                  break
                case "6":
                  var oo = []
                  if (sub && sub.length > 0) {
                    for (var d = 0; d < sub.length; d++) {
                      if (
                        sub[d].answe &&
                        sub[d].answe != null &&
                        sub[d].answe != ""
                      ) {
                        oo.push({ answe: sub[d].answe })
                      }
                    }
                    obs = oo
                  } else {
                    obs = []
                  }
                  break
                case "3":
                  obs = sem
                  break
                case "8,9":
                  obs = sem
                  break
                case "10":
                  obs = sem
                  break
                case "11":
                  var oo = []
                  if (
                    question.answe &&
                    question.answe != null &&
                    question.answe != ""
                  ) {
                    oo.push({ answe: question.answe })
                    obs = oo
                  } else {
                    obs = []
                  }
                  break
                default:
                  obs = sub
                  break
              }

              for (var w in obs) {
                if (Array.isArray(obs[w].answe) || type.basic_ques_types == 6) {
                  console.log(obs[w].answe)
                  if (type.basic_ques_types == 6) {
                    if (JSON.stringify(obs[w].answe) == "{}") {
                      part[w] = null
                    } else {
                      var oh = obs[w].answe
                      for (var s in oh) {
                        part[s] = oh[s] ? oh[s] : null
                      }
                    }
                  } else {
                    obs[w].answe.map((item_ans, index_ans) => {
                      // part[index_ans] = item_ans
                      if (JSON.stringify(item_ans) == "{}") {
                        part[index_ans] = null
                      } else {
                        part[index_ans] = item_ans
                      }
                    })
                  }
                } else {
                  if (obs[w].answe instanceof Object) {
                    var onh = obs[w].answe
                    for (let ke in onh) {
                      // iii[ke]=onh[ke]
                      part[ke] = onh[ke]
                      // part.push({ke:onh[ke]})
                    }
                    // console.log(`存在'key:value'数据`,type.basic_ques_types, part)
                  } else {
                    part[w] = obs[w].answe
                    // part.push(obs[w].answe)
                  }
                }
                // console.log(`类型是`, type.basic_ques_types,part)
                for (let i = 0; i < part.length; i++) {
                  if (part[i] == null || part[i] == undefined) {
                    part[i] = ""
                  }
                }
              }
              that.answerList.push({
                que_id: obj.parts[a].question.id,
                part_id: obj.parts[a].id,
                answer: part,
              })
            }
          }
        })
        var arr = JSON.stringify(that.answerList)
        that.$axios
          .post("/app/exam_enroll_student/answer", {
            answer_data: arr,
            examination_id: that.$route.query.examination_id,
          })
          .then((res) => {
            if (res.code == 1) {
              window.clearTimeout(that.timer)
              that.$Message.success("交卷成功")
              that.$router.go(-1)
            } else {
              that.$Message.error(res.msg)
            }
          })
      },
      lookcancel() {
        this.lookShow = false
        this.$router.go(-1)
      },
      sureInfo() {
        //确认信息
        var that = this
        console.log("/app/exam_enroll_student/beginAnswer2?examination_id=" + that.looksInfo.examination.id)
        that.$axios
          .get(
            "/app/exam_enroll_student/beginAnswer2?examination_id=" +
            that.looksInfo.examination.id
          )
          .then((res) => {
            if (res.code == 1) {
              that.lookShow = false
              that.$Message.success(res.data)
              that.getstudent()
            } else {
              that.$Message.error(res.msg)
            }
          })
      },
    },
  }
</script>
<style scoped lang='less'>
  .exams {
    width: 86%;
    margin: 0 auto;
    .exams-row {
      width: 100%;
      padding: 10px 10px 10px 30px;
      display: flex;
      justify-items: center;
      justify-content: space-between;
      align-items: center;
      background: #eee;
      .exams-rowcol {
        display: flex;
        justify-content: space-around;
        align-items: center;
        .exams-rowdiv {
          display: flex;
          align-items: center;
        }
        .exams-rowcol-drop {
          font-size: 16px;
          .exams-rowcol-d {
            min-width: 24vw;
            max-width: 50vw;
            max-height: 60vh;
            margin-left: 12vw;
            overflow: auto;
          }
          .exams-rowcol-drop-tit {
            font-size: 16px;
            margin: 6px 0;
            color: #333;
          }
          .exams-rowcol-drop-div {
            font-size: 15px;
            margin: 6px 20px;
            div {
              display: inline-block;
            }
            a {
              display: inline-block;
              border-radius: 50%;
              margin: 6px 10px;
              width: 30px;
              height: 30px;
              color: #aaa;
              line-height: 30px;
              text-align: center;
              align-items: center;
              border: 1px solid #aaa;
            }
          }
        }
      }
      .exams-right {
        display: flex;
        justify-content: flex-end;
        p {
          color: #2d8cf0;
          font-size: 24px;
          font-weight: 600;
        }
      }
    }
    .exams-rowp {
      background: #549ce9;
      padding: 0px 20px;
      height: 32px;
      display: flex;
      align-items: center;
      border-radius: 20px;
      color: #fff;
      p {
        max-width: 47%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .icon {
        width: 4%;
        height: 100%;
      }
    }
    .exams-p {
      width: 100%;
      background: #ddd;
      line-height: 2.4;
      font-size: 16px;
      text-align: center;
    }
    .exams-list {
      width: 100%;
    }
  }
  .shuomingpop {
    max-height: 70vh;
    overflow: auto;
    padding: 10px;
    .shuomingp {
      width: 100%;
      text-align: center;
    }
    .xinfos {
      padding: 10px 30px;
      p {
        background: #eee;
        padding: 10px 30px;
        margin-bottom: 4px;
      }
    }
    .shuoming {
      padding: 20px;
      p {
        font-weight: 600;
        text-align: center;
        color: #000;
      }
    }
  }
  //考题样式从这到底
  /deep/.text>* {
    display: inline-block;
  }
  /deep/pre {
    // border-bottom: 1px solid #333;
    display: inline-block;
    margin: 0;
    padding: 0 20px;
    min-width: 100px;
    color: #549ce9;
  }
  //选项颜色
  /deep/.ivu-radio-disabled .ivu-radio-inner:after {
    background: #549ce9;
  }
  /deep/.ivu-radio-checked .ivu-radio-inner {
    border-color: #549ce9;
  }
  /deep/img {
    max-width: 320px !important;
  }
  /deep/textarea {
    display: inline-block;
    // width: 100% !important;
  }
  /deep/ .select label {
    font-size: 1vw;
  }
  /deep/input {
    border: none;
    border-bottom: 1px solid #999 !important;
    outline: none;
    text-align: center;
    font-weight: bold;
    color: #549ce9;
    width: 20vw;
    background: #fafafa;
  }
  //音频播放器样式修改
  .audio {
    padding: 10px 30px 5px 0;
    margin-bottom: 10px;
  }
  audio::-webkit-media-controls {
    border: 0;
    width: 380px !important;
    height: 80px !important;
    display: flex;
    align-items: center;
  }
  /* 音频面板 */
  audio::-webkit-media-controls-panel {
    background: #fff;
  }
  /* 音量按钮 */
  audio::-webkit-media-controls-mute-button {
    background: #fff;
  }
  /* 播放按钮 */
  audio::-webkit-media-controls-play-button {}
  audio::-webkit-media-controls-play-button-icon {
    background: #fff;
    width: 50px;
    height: 50px;
  }
  audio::-webkit-media-controls-timeline-container {
    background: rgb(129, 128, 128);
  }
  /* 当前播放时长 */
  audio::-webkit-media-controls-current-time-display {}
  /* 总时长 */
  audio::-webkit-media-controls-time-remaining-display {}
  /* 播放进度条 */
  audio::-webkit-media-controls-timeline {
    // display: none;
    width: 100px;
    //进度
  }
  /* 音量滑条面板 */
  audio::-webkit-media-controls-volume-slider-container {}
  audio::-webkit-media-controls-volume {
    background: rgb(6, 173, 145);
  }
  /* 音量滑条 */
  audio::-webkit-media-controls-volume-slider {
    // background: rgb(6, 173, 145);
    display: none;
    // 音量进度
  }
  //大盒子
  .box {
    padding: 30px;
    background: #fff;
  }
  .empty {
    position: relative;
    top: 20px;
    text-align: center;
    font-size: 20px;
  }
  //h4 是问题字段
  h4 {
    display: flex;
    // align-items: center;
    padding-left: 10px;
    padding-top: 10px;
    margin-bottom: 10px;
    //小标题下标
    .index {
      flex-shrink: 0;
      box-sizing: border-box;
      width: 24px;
      height: 24px;
      line-height: 25px;
      text-align: center;
      display: inline-block;
      background: #549ce9;
      border-radius: 50%;
      margin-right: 16px;
      color: #fff;
      font-size: 16px;
      font-weight: bold;
    }
  }
  //考题大盒子
  .questions {
    padding: 10px;
    background: #fafafa;
    width: 100%;
    height: 70vh;
    overflow: auto;
    .questions_title {
      // margin-bottom: 20px;
      font-size: 20px;
      line-height: 25px;
      padding: 18px 20px 4px;
      background: #fafafa;
      position: relative;
    }
    .question_content {
      align-items: center;
      font-size: 17px;
      line-height: 28px;
    }
  }
  .select label {
    width: 100%;
    padding: 10px 10px 10px 45px;
    line-height: 20px;
    border-radius: 4px;
    cursor: pointer;
    margin: 0;
    position: relative;
    min-height: 40px;
    height: auto;
    display: flex;
  }
  .select_no label,
  .select_no p {
    width: 100%;
    padding: 10px 10px 10px 45px;
    line-height: 20px;
    border-radius: 4px;
    cursor: pointer;
    margin: 0;
    position: relative;
    min-height: 40px;
    height: auto;
    display: flex;
    /deep/.ivu-radio-disabled {
      display: none;
    }
  }
  /deep/span img {
    vertical-align: top;
  }
  /deep/ textarea {
    outline: none;
    font-weight: bold;
    color: #549ce9;
    width: 62vw;
    border: 1px solid #999 !important;
  }
  /deep/ .input9 {
    min-width: 20vw;
  }
</style>
